import { BlogPost } from "@/types/blog-post";

import body from "./body.mdx";

const introducingMml: BlogPost = {
  title: "August 2023: React, Collision Events, and More",
  description: "Check out what's been added since MML's initial release up to August 2023.",
  date: "2023-08-09",
  body,
  image: "/images/blog/aug-2023.jpeg",
};

export default introducingMml;
